import { render } from "./SelectionView.vue?vue&type=template&id=cd72db68&scoped=true"
import script from "./SelectionView.vue?vue&type=script&lang=js"
export * from "./SelectionView.vue?vue&type=script&lang=js"

import "./SelectionView.vue?vue&type=style&index=0&id=cd72db68&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/freefi_meal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd72db68"]])

export default __exports__